import React from 'react';
import Editor from '../../Editor';
import { EditorProps } from '../../types';
import cn from 'classnames';
import { extConfig } from './config';
import GroupAboutBubbleMenu from '../../../menus/GroupAboutBubbleMenu';

import viewerStyles from '../../../Viewer/presets/UserDonations/UserDonations.scss';
import s from './UserDonations.scss';

const UserDonationsEditor: React.FC<
  Omit<EditorProps, 'extensionConfig' | 'presetId'>
> = props => {
  return (
    <>
      <Editor
        {...props}
        withinModal
        presetId="userdonations"
        className={cn(s['root'], viewerStyles['root'])}
        extensionConfig={extConfig}
      >
        {(editor, scrollContainer) => (
          <GroupAboutBubbleMenu scrollContainerRef={scrollContainer} />
        )}
      </Editor>
    </>
  );
};
UserDonationsEditor.displayName = 'UserDonationsEditor';

export default UserDonationsEditor;
